export default __webpack_public_path__ + "media/images/promo-block/stationery-278539e6a9f602209ddaf49342d4d380.jpg";